export default "__VITE_ASSET__D$MUWEn$__"